import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {SMALL_TEXT_PX, SECONDARY_FONT_COLOR, FONT_FAMILY_REGULAR, FONT_FAMILY_DEMI, BASE_TEXT_PX, RED_FONT_COLOR, SEMANTIC_TEXT_SMALL_PX} from '../../styles/fonts/MCFontConstants';

export const Title = styled.div`
    //font-family: Avenir Next World;
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : FONT_FAMILY_DEMI};
    color: ${(props) => (props.color ? props.color : SECONDARY_FONT_COLOR)};
    width: ${(props) => (props.width ? props.width : '')};
    font-size: ${(props) => (props.fontSize ? props.fontSize : SMALL_TEXT_PX)};
    padding-bottom: ${(props) => (props.paddingBtm ? props.paddingBtm : '0px')};
    padding-top: ${(props) => (props.paddingTop ? props.paddingTop : '0px')};
    padding-right: ${(props) =>
        props.paddingRight ? props.paddingRight : '0px'};
    padding-left: ${(props) => (props.paddingLeft ? props.paddingLeft : '0px')};
    .asterisk {
        color: red;
        padding-left: 3px;
    }
    ${media.mobileDevice`
    width: ${(props) => (props.mbWidth ? props.mbWidth : '')};
    padding-bottom: ${(props) =>
        props.mbpaddingBtm ? props.mbpaddingBtm : '0px'};
    padding-top: ${(props) =>
        props.mbpaddingTop ? props.mbpaddingTop : '0px'};
         padding-right: ${(props) =>
             props.mbpaddingRight ? props.mbpaddingRight : '0px'};
    padding-left: ${(props) =>
        props.mbpaddingLeft ? props.mbpaddingLeft : '0px'};
    `};

    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
        width: ${(props) => (props.isTab === true ? '270px' : '')};
    }
`;

export const StyledText = styled.div`
    font-size: ${(props) => (props.fontSize ? props.fontSize : BASE_TEXT_PX)};
    letter-spacing: 0px;
    margin-top: ${(props) => props.marginTop || ''};
    color: ${SECONDARY_FONT_COLOR};
    opacity: 1;
    font-family: ${FONT_FAMILY_REGULAR};
`;

export const AlertText = styled.div`
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${(props) => (props.fontSize ? props.fontSize : SEMANTIC_TEXT_SMALL_PX)};
    letter-spacing: -0.1px;
    color: ${(props) => (props.color ? props.color : RED_FONT_COLOR)};
    opacity: 1;
    padding: ${(props) => props.padding};
    display: flex;
`;
